import React from "react";
import { ButtonGroup, Button } from "reactstrap";

/**
 * Asset-class selector shared by the Track Record diagnostics and the By-Conviction
 * ramp. The backend stratifies both by asset class (`diagnostics.by_asset_class` /
 * strength `by_asset_class`) so a trending FX/crypto instrument's "edge" — really
 * momentum on a secular trend — is measured against ITS OWN base rate instead of being
 * pooled with equities. "Equity" is the honest default view.
 */
export const ASSET_CLASS_LABELS: Record<string, string> = {
  all: "All",
  equity: "Equity",
  forex: "Forex",
  crypto: "Crypto",
  futures: "Futures",
};

// Display order; "all" + "equity" always shown, the rest only when present in the data.
export const ASSET_CLASS_ORDER = ["all", "equity", "forex", "crypto", "futures"];

export default function AssetClassToggle({
  value,
  onChange,
  available,
}: {
  value: string;
  onChange: (v: string) => void;
  available: Set<string>;
}) {
  // "all" plus whatever classes the payload actually contains — so the toggle simply
  // doesn't appear until the backend stratification is deployed / data regenerated.
  const ids = ASSET_CLASS_ORDER.filter((id) => id === "all" || available.has(id));
  if (ids.length <= 1) return null;

  return (
    <ButtonGroup size="sm" className="flex-wrap">
      {ids.map((id) => {
        const active = id === value;
        return (
          <Button
            key={id}
            type="button"
            outline={!active}
            onClick={() => onChange(id)}
            style={{
              padding: "2px 10px",
              fontSize: 12.5,
              borderColor: "var(--border-color)",
              color: active ? "#fff" : "var(--text-muted)",
              backgroundColor: active ? "var(--primary)" : "transparent",
            }}
          >
            {ASSET_CLASS_LABELS[id]}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
